import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function WhatsAppButton() {
  const { settings } = useSettings();
  const num = (settings.whatsapp_number || "").replace(/[^0-9]/g, "");
  const href = `https://wa.me/${num}?text=${encodeURIComponent("Hi! I'd like to know more about your indoor cricket arena.")}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      className="pz-pulse fixed z-40 bottom-6 left-6 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white shadow-lg flex items-center justify-center transition-transform hover:scale-110"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2.4} />
    </a>
  );
}
